var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnonymous(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#333333;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M491.8,154.9L491.8,154.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M808.4,234.1v275.7c0,22-9.4,41-23.1,50.2H284.8c-13.7-9.1-23.1-28.2-23.1-50.2V234.1l21-55.9 c5.7-7.1,13.1-11.2,21.1-11.2h13.2c6.5,0,12.7,2,18.4,5.8c5.5,3.7,10.4,9,14.3,15.8C396,269.9,465,321.5,542.1,321.5 s146.1-51.6,192.3-132.8c3.8-6.8,8.8-12.1,14.3-15.8c5.5-3.7,11.7-5.7,18-5.8c7.8,0.1,15.2,4.2,20.7,11.1L808.4,234.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M882.5,560h-695c-23.2,0-38.3-33.2-27.7-61.2l101.9-270.5l14.4-38.3c1.7-4.5,4-8.5,6.6-11.8 c5.7-7.1,13.1-11.2,21.1-11.2h13.2c6.5,0,12.7,2,18.4,5.8c5.5,3.7,10.4,9,14.3,15.8C396,269.9,465,321.5,542.1,321.5 s146.1-51.6,192.3-132.8c3.8-6.8,8.8-12.1,14.3-15.8c5.5-3.7,11.7-5.7,18-5.8c7.8,0.1,15.2,4.2,20.7,11.1 c2.7,3.3,4.9,7.3,6.6,11.8l14.4,38.3l101.9,270.5C920.8,526.8,905.8,560,882.5,560z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M488.6,843.2c-28.2,60.5-81.6,100-150.4,84.2c-68.7-15.8-95.5-74.2-98.6-141.4 c-3.1-67.9,85.8-111.1,154.5-95.3S517.3,781.7,488.6,843.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M588.2,850.7c32.2,58.6,88.1,94.8,155.7,75.1s90.5-79.4,89.1-146.6c-1.4-67.7-93-105.6-160.5-85.8 S555.5,791.1,588.2,850.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M657.2,799.2c0,3.6-1.4,7.1-3.9,10.4c-13.7-17.8-61.4-30.9-118.2-30.9c-56.8,0-104.5,13.1-118.2,30.9 c-2.6-3.3-3.9-6.8-3.9-10.4c0-22.8,54.7-41.3,122.1-41.3S657.2,776.4,657.2,799.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1031.6,637.6H48.4c-4.7,0-8.5-3.8-8.5-8.5v-16.9c0-4.7,3.8-8.5,8.5-8.5h983.2c4.7,0,8.5,3.8,8.5,8.5v16.9 C1040,633.8,1036.3,637.6,1031.6,637.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnonymous);
export default __webpack_public_path__ + "static/media/anonymous.115445517a0729d0d2aaf009e20f1b5a.svg";
export { ForwardRef as ReactComponent };